import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { Pencil, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";
import { IItemHistoricoServico } from "../../../../types";

const detectaServicoEditado = (acao: string): boolean => {
  const acaoLower = acao.toLowerCase().trim();
  return acaoLower === 'edição' || acaoLower.includes('serviço editado');
};

const getIconServicoEditado = (acao: string): { Icon: LucideIcon; color: string } => {
  return { Icon: Pencil, color: 'var(--c8041c7)' };
};

export default function CardServicoEditado({ item, isExpanded, onToggleExpand }: CardHistoricoProps) {
  // Este card é específico para serviços, então fazemos type assertion
  const itemServico = item as IItemHistoricoServico;
  
  return (
    <CardHistoricoBase
      item={item}
      icon={getIconServicoEditado(item.acao)}
      temExpansaoDisponivel={true}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      expandedContent={<ExpandedContent item={itemServico} />}
      tituloCustomizado="Serviço editado"
    />
  );
}

export const servicoEditadoConfig = {
  tipo: 'servico_editado',
  detectaTipo: detectaServicoEditado,
  getIcon: getIconServicoEditado,
  temExpansao: () => true,
  Component: CardServicoEditado
};
